export default "__VITE_ASSET__D0s07JEi__"